export const getTriggerInitialState = () => ({
    redirectTo: '',
    query: '',
    executions: [],
    notifications: [],
    queryModification: { originalQuery: '', newQuery: '', queryToIgnore: '' },
});
